import { useTranslation } from 'react-i18next'
import { Navigate, useLocation } from 'react-router'

import { FALLBACK_LANGUAGE } from '@app/i18n'

import { getLocaleFromPath, localizeUrl, type SupportedLocale } from './utils'

export function LocaleRedirect () {
  const { i18n } = useTranslation()
  const location = useLocation()

  if (getLocaleFromPath(location.pathname)) {
    return null
  }

  const targetLocale = (i18n.language || FALLBACK_LANGUAGE) as SupportedLocale
  const localizedPath = localizeUrl(
    location.pathname + location.search + location.hash,
    targetLocale,
  )

  return <Navigate to={localizedPath} replace />
}
